import { parseBreakdownGroups } from "./parse";

interface BreakdownBarsProps {
  content: string;
}

/** Segment color palette — teal family for multi-segment, warm clay for solo. */
const SEGMENT_COLORS = [
  "var(--color-teal-1, var(--color-accent))",
  "var(--color-teal-2, #2A7A6E)",
  "var(--color-teal-3, #3A8F95)",
  "var(--color-teal-4, #4DA3A8)",
  "var(--color-teal-5, #6BBDC2)",
];
const SOLO_COLOR = "var(--color-property-warm, #C08070)";

export function BreakdownBars({ content }: BreakdownBarsProps) {
  const groups = parseBreakdownGroups(content);
  if (groups.length === 0) return null;

  return (
    <div className="cx-breakdown">
      {groups.map((group, gi) => {
        const total = group.segments.reduce((sum, s) => sum + s.value, 0);
        const isSolo = group.segments.length === 1;

        return (
          <div key={gi} className="cx-breakdown-group">
            <div className="cx-breakdown-header">{group.header}</div>
            <div className="cx-breakdown-bar">
              {group.segments.map((seg, si) => {
                const pct = total > 0 ? (seg.value / total) * 100 : 0;
                const color = isSolo ? SOLO_COLOR : SEGMENT_COLORS[si % SEGMENT_COLORS.length];

                // Format value for display
                const displayVal = seg.value >= 1000
                  ? `${Math.round(seg.value).toLocaleString("sv-SE")}`
                  : seg.value.toLocaleString("sv-SE");

                const label = `${seg.label} · ${displayVal} (${Math.round(pct)}%)`;
                const shortLabel = `${seg.label} · ${displayVal}`;

                return (
                  <div
                    key={si}
                    className={`cx-breakdown-segment${isSolo ? " cx-breakdown-segment--solo" : ""}`}
                    style={{
                      flex: pct,
                      background: color,
                      animationDelay: `${50 + si * 100}ms`,
                    }}
                    title={label}
                  >
                    {pct >= 15 ? label : pct >= 8 ? shortLabel : ""}
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}
